import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const CarrierVoiceAccountsCreateEgress = () => {

    const [data, setData] = useState({
        ATRDIRECTION: 1, 
    });
    const [metadata, setMetadata] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const carrierId = useParams().carrier_id;
    const navigate = useNavigate();

    useEffect(() => {
        getOne(`/admin/carriers/carriers/${carrierId}/voiceaccounts/`, 'new_egress')
            .then(response => {
                setMetadata(response.data.metadata);
            }).catch(error => {
                toast.error("Error fetching carrier: " + error.message, {});
            });
    }, [carrierId]);

    const handleSave = () => {
        create(`/admin/carriers/carriers/${carrierId}/voiceaccounts`, {data: data}).then(response => {
            toast.success("Carrier created successfully", {});
            navigate(`/carriers/carriers/${carrierId}/voiceaccounts`);
        }).catch(error => {
            toast.error("Error creating carrier: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/carriers/carriers/${carrierId}/voiceaccounts`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageSelect label="Authentication Type" id="ATRAUTHTYPEID" onChange={ onChange } value={ data.ATRAUTHTYPEID } options={ metadata?.auth_types?.values } />
                    <EditPageTextField label="Name" id="ATRALIAS" onChange={ onChange } value={ data.ATRALIAS } />
                    <EditPageTextField label="IP Address" id="ATRIPADDR" onChange={ onChange } value={ data.ATRIPADDR } />
                    <EditPageTextField label="Port" id="port" onChange={ onChange } value={ data.port } />
                    <EditPageTextField label="Prefix" id="ATRPREFIX" onChange={ onChange } value={ data.ATRPREFIX } />
                    <EditPageSelect label="Rate Profile" id="ATRPRODUCTID" onChange={ onChange } value={ data.ATRPRODUCTID } options={ metadata?.products?.values } />
                    <EditPageSelect label="Caller ID Group" id="caller_id_rewrite_group_id" onChange={ onChange } value={ data.caller_id_rewrite_group_id } options={ metadata?.callerIdGroups?.values } />
                    <EditPageCheckbox label="Enabled" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default CarrierVoiceAccountsCreateEgress;